"use client";

import { useQuery } from "@tanstack/react-query";
import { getSessionCapabilities } from "@/lib/api/session-capabilities";
import { useOptionalAuth } from "@/lib/auth/auth-context";

/**
 * The caller's role (platform operator; the organisation that resolves), read
 * once per signed-in subject. Read only for a signed-in session, or in the
 * mock console (no identity provider); never for an anonymous visitor.
 */
export function useSessionCapabilities() {
  const auth = useOptionalAuth();
  const status = auth?.status ?? "unconfigured";
  const enabled = status === "authenticated" || status === "unconfigured";
  return useQuery({
    queryKey: ["session-capabilities", auth?.claims?.sub ?? "local"],
    queryFn: () => getSessionCapabilities(),
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
